module.exports = __webpack_public_path__ + "static/media/runk & pratt garage.260b9ca4.jpeg";